import "./Insights.module.css";
import Header from "@/reusable_sections/Header";
import NeuralInsightsBlog from "./sections/NeuralInsightsBlog";
import JoinTheNetwork from "./sections/JoinTheNetwork";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <Header />
      <NeuralInsightsBlog />
      <JoinTheNetwork />
      <Footer />
    </div>;
}